import PropTypes from 'prop-types'
import {useEffect} from 'react'
import {List, Map} from 'immutable'

import AccountInformation from '../shared_components/account_information/AccountInformation'
import AccountSummary from '../shared_components/account_summary/AccountSummary'
import ClientActions from '../../actions/ClientActions'
import EverplanDetails from '../shared_components/everplan_details/EverplanDetails'
import FuneralHomeHeading from '../shared_components/FuneralHomeHeading'
import HouseholdHeading from './heading/HouseholdHeading'
import RemoveClientController from '../shared_components/remove_clients/RemoveClientController'
import SplitHouseholdController from './household_split/SplitHouseholdController'

import {allUsersDeceased} from '../../../../lib/tools'
import {useNotificationContext} from '../../../../shared_components/notifications/NotificationContext'
import {isFuneralHome} from '../../lib/firmTools'
import storeWrapper from '../../../../shared_components/storeWrapper'
import {usePrevious} from '../../../../lib/hooks'

const Household = props => {
  const prevClientInformation = usePrevious(props.editClientNotification.data)
  const {isDifferent} = useNotificationContext()

  useEffect(() => {
    isDifferent(props.editClientNotification.data, prevClientInformation).shortSuccess('Client information updated.')
  }, [props.editClientNotification.data])

  const isAnyEverplanUserActive = props.clientSeats.some(clientSeat => clientSeat.get('status') === 'Active')

  const household = props.household.data

  return (
    <div>
      {props.children}
      <div className='household'>
        {
          isFuneralHome(props.firm) ?
            <FuneralHomeHeading clientName={props.household.data.name} /> :
            <HouseholdHeading
              {...household}
              firmConfig={props.firmConfig}
              isAnyEverplanUserActive={isAnyEverplanUserActive}
              params={props.params}
            />

        }
        <AccountInformation
          clientSeats={props.clientSeats}
          clients={props.household.data.clients}
          firm={props.firm}
          params={props.params}
        />
        <AccountSummary
          anyoneActive={isAnyEverplanUserActive}
          allUsersDeceased={allUsersDeceased(household.clients)}
          currentUser={props.currentUser}
          data={household}
          everplanSummary={props.everplanSummary}
          firm={props.firm}
          firmOwnership={props.firmOwnership}
          itemResponses={props.itemResponses}
          quarterbackOwnership={props.quarterbackOwnership}
        />
        <EverplanDetails {...props} everplanSummary={props.everplanSummary} />
        <RemoveClientController
          {...props}
        />
        <SplitHouseholdController {...props} />
      </div>
    </div>
  )
}

Household.defaultProps = {
  household: {
    data: {
      name: '',
      advisor: {name: ''},
      clients: [],
      plan_stats: [],
      items_updated: 0,
      user_id: null
    }
  }
}

Household.propTypes = {
  currentUser: PropTypes.instanceOf(Map),
  editClientNotification: PropTypes.shape({
    data: PropTypes.shape({
      message: PropTypes.string
    })
  }),
  everplanSummary: PropTypes.instanceOf(Map),
  firm: PropTypes.instanceOf(Map),
  firmConfig: PropTypes.instanceOf(Map),
  firmOwnership: PropTypes.instanceOf(Map),
  quarterbackOwnership: PropTypes.instanceOf(Map),
  owners: PropTypes.instanceOf(List),
  household: PropTypes.shape({
    data: PropTypes.shape({
      advisor: PropTypes.shape({
        name: PropTypes.string
      }),
      items_updated: PropTypes.number,
      name: PropTypes.string,
      clients: PropTypes.array
    })
  }).isRequired,
  params: PropTypes.shape({
    clientSeatId: PropTypes.string.isRequired
  }),
  clientSeats: PropTypes.instanceOf(List)
}

export default storeWrapper(
  Household,
  [{actionTypes: [ClientActions.Types.DID_UPDATE_CLIENT], name: 'editClientNotification'}]
)
